<template>
  <div v-loading="loading" class="orderdeatil_content">
    <div class="left">
      <el-page-header @back="goBack" content="课程卡下单"></el-page-header>
      <div class="hujisf">
        <el-form label-width="140px" class="fonme">
          <el-form-item label="订单编号：">
            <el-row :gutter="20">
              <el-col :span="6">{{ xqlist.orderCode }}</el-col>
              <el-col :span="6">下单时间：{{ xqlist.createTime }}</el-col>
              <!-- <el-col :span="5">下单人：{{ xqlist.creatorName }}</el-col> -->
              <el-col :span="5"
              style="text-align: right;color: red;font-size:14px"
                >订单状态：{{
                  xqlist.orderStatus == 1
                    ? "待发货"
                    : xqlist.orderStatus == 2
                    ? "待发货"
                    : xqlist.orderStatus == 3
                    ? "待发货"
                    : xqlist.orderStatus == 4
                    ? "待签收"
                    : "已签收"
                }}</el-col
              >
            </el-row>
          </el-form-item>
          <el-form-item label="收货人信息：">
            {{ xqlist.printAddressDetail }}({{ xqlist.receiverName }}
            {{ xqlist.receiverMobile }})
          </el-form-item>
          <!-- <el-form-item label="印制厂家：">
            {{ xqlist.managerUserName }}
          </el-form-item> -->
          <!-- <el-form-item label="期望送达学校时间：">
            {{ xqlist.hopeSendTime }}
          </el-form-item> -->
          <!-- <el-form-item label="适用小程序：">
            {{ xqlist.mpName }}
          </el-form-item> -->
          <el-form-item label="课程卡适用周期：">
            {{ xqlist.openTime }} - {{ xqlist.expireTime }}
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="jiaodans">
      <el-row :gutter="20">
        <el-col :span="6">{{ xqlist.cardPrintPredict&&xqlist.cardPrintPredict.schoolName }}</el-col>
        <el-col :span="5"
          >名称：{{ xqlist.cardPrintPredict&&xqlist.cardPrintPredict.predictName }}</el-col
        >
        <!-- <el-col :span="5">时间：{{ xqlist.updateTime }}</el-col> -->
        <el-col :span="5"
          >定制人：{{ xqlist.cardPrintPredict&&xqlist.cardPrintPredict.updaterName }}</el-col
        >
        <el-col :span="3" style="color: red;">总卡量：{{ xqlist.printNum }}</el-col>
      </el-row>
    </div>
    <el-table
      :data="xqlist.cardPrintPredictDetailImgVoList"
      border
      stripe
      style="width: 100%; margin-top: 15px"
    >
      <el-table-column type="index" align="center"></el-table-column>
      <el-table-column
        prop="courseName"
        label="课程名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="courseName"
        label="课程卡反面"
        align="center"
      >
      <template slot-scope="scope">
          <el-image 
            style="width: 90px;"
            :src="img + scope.row.cardBack" 
            :preview-src-list="scope.row.srcList">
        </el-image>
          <!-- <img
              :src="img + scope.row.cardFront"
              class="shanj"
            /> -->
      </template>
      </el-table-column>
      <el-table-column
        prop="courseName"
        label="课程卡正面"
        align="center"
      >
      <template slot-scope="scope">
          <el-image 
            style="width: 90px;"
            :src="img + scope.row.cardFront" 
            :preview-src-list="scope.row.srcList1">
        </el-image>
          <!-- <img
              :src="img + scope.row.cardBack"
              class="shanj"
            /> -->
      </template>
      </el-table-column>
      <el-table-column
        label="印制数量"
        align="center"
        prop="printNum"
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
import * as homeApi from "@/api/observation";
export default {
  components: {},
  data() {
    return {
      loading: false,
      xqlist: {

      },
      id: "",
      img: "https://xm-evaluate-file.oss-cn-beijing.aliyuncs.com/",
      srcList:[]
    };
  },
  watch: {},
  methods: {
    goBack() {
      // this.$emit("navlink", "bazaar_customization");bazaar_record
      // if(localStorage.getItem("isdk")==1){
      //     this.$emit("navlink", "bazaar_order");
      // }else{
      //     this.$emit("navlink", "bazaar_record");
      // }
      this.$emit('backBench','order')
    },
    getCardPrintOrderInfo() {
      let that = this;
      let params = {
        orderId: this.id,
      };
      that.loading=true
      homeApi
        .getCardPrintOrderInfo(params)
        .then((res) => {
            for(var i=0;i<res.data.data.cardPrintPredictDetailImgVoList.length;i++){
                res.data.data.cardPrintPredictDetailImgVoList[i].srcList=[]
                res.data.data.cardPrintPredictDetailImgVoList[i].srcList.push(that.img+res.data.data.cardPrintPredictDetailImgVoList[i].cardBack)
                res.data.data.cardPrintPredictDetailImgVoList[i].srcList1=[]
                res.data.data.cardPrintPredictDetailImgVoList[i].srcList1.push(that.img+res.data.data.cardPrintPredictDetailImgVoList[i].cardFront)
            }
          that.xqlist = res.data.data;
          that.loading=false
        })
        .catch(() => {that.loading=false});
    },
  },
  mounted() {
    this.schoolId = localStorage.getItem("idschoolId");
    this.id = localStorage.getItem("ddid");
    this.getCardPrintOrderInfo();
  },
};
</script>

<style lang="less">
.fonme {
  background-color: rgb(243, 247, 254);
  padding: 10px;
  border-radius: 5px;
  margin-top: 15px;
}
.jiaodans {
  background-color: rgb(254, 247, 226);
  margin: 10px 0;
  padding: 10px;
  border-radius: 5px;
}
.frijk {
  text-align: right;
  margin: 15px 0;
}
.hujisf .el-form-item {
  margin-bottom: 0;
}
.shanj{
    width: 90px;
    
}
.el-image-viewer__close i{
    font-size: 40px !important;
    color: #fff;
}
.orderdeatil_content{
  box-sizing: border-box;
  padding: 10px; 
  height: 100%;
  background:#fff;
}
.el-col-6,.el-col-3,.el-col-5{
  font-size:14px;
}
</style>


// WEBPACK FOOTER //
// src/views/bench/components/orderDetail.vue